import { myLeaveRequestConstants } from "../constant/myLeaveRequest.constants";

export const initialState = {
    listLeaveType: [],
    listSummary: [],
    listRequest: [],
    errorCode: "",
    successCode: "",
    isLoading: false,
    searching: false,
    updating: false,
    confirming: false,
    loadingPage: false,
};
const myLeaveRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case myLeaveRequestConstants.GET_LEAVE_TYPE_SUCCESS:
            return {
                ...state,
                listLeaveType: action.listType,
                isLoading: true,
            };
        case myLeaveRequestConstants.GET_SUMMARY_SUCCESS:
            return {
                ...state,
                listSummary: action.listSummary,
                isLoading: true,
            };
        case myLeaveRequestConstants.GET_REQUEST_LIST:
            return {
                ...state,
                updating: true,
                searching: true,
            };
        case myLeaveRequestConstants.GET_REQUEST_LIST_PAGE:
            return {
                ...state,
                loadingPage: true,
            };
        case myLeaveRequestConstants.GET_REQUEST_LIST_SUCCESS:
            return {
                ...state,
                listRequest: action.listRequest,
                isLoading: true,
                searching: false,
                loadingPage: false,
            };
        case myLeaveRequestConstants.UPDATE_CONFIRM:
            return {
                ...state,
                confirming: true,
            };
        case myLeaveRequestConstants.UPDATE_CONFIRM_SUCCESS:
            window.location = "/my-leave-request";
            return {
                ...state,
                confirming: false,
            };
        case myLeaveRequestConstants.UPDATE_CONFIRM_FAIL:
            return {
                ...state,
                confirming: false,
                errorCode: action.error,
            };
        case myLeaveRequestConstants.CLEAR_MESSAGE:
            return {
                ...state,
                errorCode: "",
            };
        default:
            return state;
    }
};

export default myLeaveRequestReducer;
